export default {
  computed: {
    kw_filter: function() {
      return this.unigrams.filter((i) => {
        if (this.kw_search.length == 0) { return '' } else {
          // console.log('kwfilter' + i['word'].match(this.kw_search.join('|')));
          return i['word'].match('^' + this.kw_search.join('$|^') + '$');
        }
      });
    },
  },
}


// WEBPACK FOOTER //
// ./src/mixins/kw_filter.js